__turbopack_context__.v({
  "asset": "Asset-module-scss-module__I3zoRq__asset",
  "assetContainer": "Asset-module-scss-module__I3zoRq__assetContainer",
  "poster": "Asset-module-scss-module__I3zoRq__poster",
  "stack-module-0": "Asset-module-scss-module__I3zoRq__stack-module-0",
  "stack-module-1": "Asset-module-scss-module__I3zoRq__stack-module-1",
  "stack-module-10": "Asset-module-scss-module__I3zoRq__stack-module-10",
  "stack-module-11": "Asset-module-scss-module__I3zoRq__stack-module-11",
  "stack-module-12": "Asset-module-scss-module__I3zoRq__stack-module-12",
  "stack-module-13": "Asset-module-scss-module__I3zoRq__stack-module-13",
  "stack-module-14": "Asset-module-scss-module__I3zoRq__stack-module-14",
  "stack-module-15": "Asset-module-scss-module__I3zoRq__stack-module-15",
  "stack-module-16": "Asset-module-scss-module__I3zoRq__stack-module-16",
  "stack-module-17": "Asset-module-scss-module__I3zoRq__stack-module-17",
  "stack-module-18": "Asset-module-scss-module__I3zoRq__stack-module-18",
  "stack-module-19": "Asset-module-scss-module__I3zoRq__stack-module-19",
  "stack-module-2": "Asset-module-scss-module__I3zoRq__stack-module-2",
  "stack-module-20": "Asset-module-scss-module__I3zoRq__stack-module-20",
  "stack-module-3": "Asset-module-scss-module__I3zoRq__stack-module-3",
  "stack-module-4": "Asset-module-scss-module__I3zoRq__stack-module-4",
  "stack-module-5": "Asset-module-scss-module__I3zoRq__stack-module-5",
  "stack-module-6": "Asset-module-scss-module__I3zoRq__stack-module-6",
  "stack-module-7": "Asset-module-scss-module__I3zoRq__stack-module-7",
  "stack-module-8": "Asset-module-scss-module__I3zoRq__stack-module-8",
  "stack-module-9": "Asset-module-scss-module__I3zoRq__stack-module-9",
  "z-base": "Asset-module-scss-module__I3zoRq__z-base",
  "z-content": "Asset-module-scss-module__I3zoRq__z-content",
  "z-footer": "Asset-module-scss-module__I3zoRq__z-footer",
  "z-header": "Asset-module-scss-module__I3zoRq__z-header",
  "z-hero": "Asset-module-scss-module__I3zoRq__z-hero",
  "z-logo": "Asset-module-scss-module__I3zoRq__z-logo",
  "z-logo-effect": "Asset-module-scss-module__I3zoRq__z-logo-effect",
  "z-navigation": "Asset-module-scss-module__I3zoRq__z-navigation",
  "z-sub": "Asset-module-scss-module__I3zoRq__z-sub",
});
